import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'
import HeroPanel from './panels/HeroPanel'
import InstrumentsPanel from './panels/InstrumentsPanel'
import TestimonialPanel from './panels/TestimonialPanel'

gsap.registerPlugin(ScrollTrigger)

const PANEL_COUNT = 3

const ScrollableContent = () => {
  const rootRef = useRef(null)

  useEffect(() => {
    const root = rootRef.current
    if (!root) return

    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      touchMultiplier: 2,
      infinite: false,
    })

    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => lenis.raf(time * 1000))
    gsap.ticker.lagSmoothing(0)

    const rafId = requestAnimationFrame(() => {
      const heroPanel = root.querySelector('.hero-panel')
      const featuresPanel = root.querySelector('.features-panel')
      const testimonialPanel = root.querySelector('.testimonial-panel')
      if (!heroPanel || !featuresPanel || !testimonialPanel) return

      const wh = window.innerHeight
      const panelHeight = wh
      const panelsToSlide = PANEL_COUNT - 1
      const totalScroll = panelsToSlide * panelHeight
      const perPanelRatio = panelHeight / totalScroll

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: 'top top',
          end: () => '+=' + totalScroll,
          pin: true,
          scrub: 1.2,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      })

      tl.to(heroPanel, { x: '-100%', duration: perPanelRatio, ease: 'none' }, 0)
      tl.to(featuresPanel, { x: '-100%', duration: perPanelRatio, ease: 'none' }, perPanelRatio)
    })

    return () => {
      cancelAnimationFrame(rafId)
      lenis.destroy()
      ScrollTrigger.getAll().forEach((t) => t.kill())
    }
  }, [])

  return (
    <div ref={rootRef} className="relative w-full" style={{ minHeight: '100vh', background: '#CBB191' }}>
      <div className="absolute inset-0">
        <div className="hero-panel absolute inset-0 z-30">
          <HeroPanel />
        </div>
        <div className="features-panel absolute inset-0 z-20">
          <InstrumentsPanel />
        </div>
        <div className="testimonial-panel absolute inset-0 z-10">
          <TestimonialPanel />
        </div>
      </div>
    </div>
  )
}

export default ScrollableContent
